// Get version from package.json
import packageInfo from '../package.json';

// Export the version number
export const version = packageInfo.version;

// Export the app name
export const appName = 'Salinator for Sales';

// Export full app name with version
export const appNameWithVersion = `${appName} v${version}`; 